import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import PrivacyNotice from './pages/PrivacyNotice';
import NotFound from './pages/NotFound';
import { AnalyticsController } from './components/AnalyticsController';
import { PRIVACY_PATH } from './content/legal';

export const AppRoutes = () => (
  <div className="App">
    <AnalyticsController />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path={PRIVACY_PATH} element={<PrivacyNotice />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </div>
);